"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // sample section intro

var components_lib_1 = require("@dynamynd/components-lib");

var content_parser_1 = require("@dynamynd/content-parser");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

var enums_1 = require("../../enums");

var index_1 = require("../index");

var defaultIntroImageUri = components_lib_1.appConfig.images.addOnModulesIntroSectionOwl;

var core_1 = require("@dynamynd/core");

var AdminUrl_copy_1 = require("../../services/AdminUrl copy");

var handleLinkAddOnPress = function handleLinkAddOnPress(link) {
  if (react_native_1.Platform.OS === 'web') {
    window.open(prepareLink(link), '_blank');
  }
};

var prepareLink = function prepareLink(link) {
  var test = /^http/g;

  if (link.search(test) < 0) {
    return "https://" + link;
  }

  return link;
};

var SampleSectionIntro = function SampleSectionIntro(_a) {
  var scrollToElementHandler = _a.scrollToElementHandler;
  var personUUID = 'fe306a51-f031-43f1-805a-88b276bbc58c';
  var params = core_1.locationWebService.parseQueryParams(core_1.locationWebService.location.search);
  var title = '';
  var content = '';
  var introImageUri = '';
  var baseUrl = process.env.REACT_APP_API_BASE_URL.replace('restapi', '');

  if (params.module === '32') {
    title = 'Stress';
    content = '=$24 **Have stress? Join the club!** = []You can use your excellent Authentic Abilities to take control of reducing stress and overcoming obstacles. []We’ve shown you how to do your best. Now we’ll help you ditch all the rest. []*"Success is the Freedom to be yourself"* – Kathy Kolbe []Be you.';
    introImageUri = AdminUrl_copy_1.generateCDNBaseUrl('/images/add-ons-stress-img.svg');
  } else if (params.module === '41') {
    title = 'Tests';
    content = 'Bet you can improve your test scores by using some tricks we know work with your personal Authentic Abilities. We’ll also warn you about ways that might keep you from doing your best. []We’ve got your back.[]';
    introImageUri = AdminUrl_copy_1.generateCDNBaseUrl('/images/add-ons-tests-module-img.svg');
  }

  var link = '';

  if (title === 'Stress') {
    link += baseUrl + "/inc/print_report.cfm/mo/" + personUUID + "/Stress";
  } else if (title === 'Tests') {
    link += baseUrl + "/inc/print_report.cfm/mo/" + personUUID + "/Tests";
  }

  var introImage = introImageUri ? introImageUri : defaultIntroImageUri;
  return react_1.default.createElement(index_1.ViewSectionContainer, null, react_1.default.createElement(components_lib_1.ColumnCenteredResponsive, null, react_1.default.createElement(components_lib_1.Title, null, title), react_1.default.createElement(IntroImage, {
    source: {
      uri: introImage
    }
  }), react_1.default.createElement(components_lib_1.Button, {
    text: "Download Results",
    uppercase: true,
    type: components_lib_1.ButtonTypeEnum.primary,
    onPress: function onPress() {
      return handleLinkAddOnPress(link);
    }
  }), react_1.default.createElement(index_1.ContentContainer, {
    style: marginStyling
  }, react_1.default.createElement(components_lib_1.Paragraph, {
    size: components_lib_1.ParagraphSizeEnum.normal
  }, react_1.default.createElement(content_parser_1.ParsedContent, {
    content: content
  }))), react_1.default.createElement(index_1.ScrollDown, {
    scrollToSectionHandler: function scrollToSectionHandler() {
      return scrollToElementHandler(enums_1.ModuleSectionViewsEnum.intro);
    }
  })));
};

var marginStyling = {
  marginTop: '15px'
};
var IntroImage = styled_components_1.default(react_native_1.Image)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 415px;\n    height: 368px;\n    margin: 40px 0 60px 0;\n"], ["\n    width: 415px;\n    height: 368px;\n    margin: 40px 0 60px 0;\n"])));
exports.default = SampleSectionIntro;
var templateObject_1;